import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { HOME_MODULE_NAMESPACE, HOME_GET_MEMBERS, HOME_GET_TICKETS, HOME_GET_BLOCK, HOME_GET_TICKET_BY_CONTRACTOR, HOME_GET_SERVICE_BOOK } from '../../store/home';
import { IHomeMemberStatisticListingViewModel, IHomeTicketStatisticListingViewModel, IHomeParameter, IHomeBlockStatisticListingViewModel, IHomeContractorStatisticListingViewModel, IHomeServiceBookStatisticViewModel } from '../../models/home';
import moment = require('moment');
import { USER_MODULE_NAMESPACE } from '../../store/user/user-types.store';
import { IUserDetails } from '../../models/user';

import { AUTHORIZATION_FUNCTIONALITIES, AUTHORIZATION_MODULE_NAMESPACE } from '../../store/authorization';
import { UserTemplate } from '../../common/enums';

import { ServiceBookService } from '../../services/serviceBook.service';

const HomeStore = namespace(HOME_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE);
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)

@Component({
  components: {
    'home-charts': async () => import('./components/home-charts/HomeCharts.vue'),
    'home-members-tabular': async () => import('./components/home-members-tabular/HomeMembersTabular.vue'),
    'home-chart-loader': async () => import('./loaders/chart-loader/ChartLoader.vue'),
    'home-table-loader': async () => import('./loaders/table-loader/TableLoader.vue'),
    'modal-buy-service-book': async () => import('./components/modal-buy-servicebook/ModalBuyServiceBook.vue'),
  }
})
class HomeContainer extends Vue {

  dtSearchParameter: IHomeParameter;
  dtChartOptions: any;
  _clearTimeout: any;
  chartsLib: any
  buyServiceBookModal:boolean
  serviceBookProduct:any[]
  ServiceBookService:ServiceBookService


  get lblSetting() {
    return {
      ...require('@/locales/dashboard').default,
      ...require('@/locales/block').default,
      ...require('@/locales/service-book').default,
    }
  }

  /**
   *
   */
  constructor() {
    super();
    this.dtChartOptions = {
      ...require('@/assets/json-resources/chart-options.json')
    }
    const date = moment();
    this.dtSearchParameter = {
      startDate:date.startOf('month').add(1,'h').toISOString(),
      endDate: date.endOf('month').toISOString()
    }
    this.chartsLib = null;
    this.buyServiceBookModal = false
    this.serviceBookProduct = []
    this.ServiceBookService = new ServiceBookService()

  }

  @UserStore.Getter userInfo: IUserDetails;
  @HomeStore.Getter membersSource: IHomeMemberStatisticListingViewModel
  @HomeStore.Getter ticketSource: IHomeTicketStatisticListingViewModel
  @HomeStore.Getter averageResolutionTime: string;
  @HomeStore.Getter isLoading: boolean;
  @HomeStore.Getter isMemberStatisticLoading: boolean;
  @HomeStore.Getter isTicketStatisticLoading: boolean
  @HomeStore.Getter blockSource: IHomeBlockStatisticListingViewModel
  @HomeStore.Getter contractorSource: IHomeContractorStatisticListingViewModel
  @HomeStore.Getter serviceBookSource: IHomeServiceBookStatisticViewModel
  @HomeStore.Getter IsServiceBookSourceLoading: boolean

  @HomeStore.Action(HOME_GET_MEMBERS)
  storeGetMemberStatistic: (param: { start: string, end: string }) => Promise<IHomeMemberStatisticListingViewModel>

  @HomeStore.Action(HOME_GET_TICKETS)
  storeGetTicketStatistic: (param: { start: string, end: string }) => Promise<IHomeTicketStatisticListingViewModel>

  @HomeStore.Action(HOME_GET_BLOCK)
  storeGetBlockStatistic: (param: { start: string, end: string }) => Promise<IHomeBlockStatisticListingViewModel>

  @HomeStore.Action(HOME_GET_TICKET_BY_CONTRACTOR)
  storeGetContractorStatistic: (param: { start: string, end: string }) => Promise<IHomeContractorStatisticListingViewModel>

  @HomeStore.Action(HOME_GET_SERVICE_BOOK)
  storeGetServiceBookStatistic: () => Promise<IHomeServiceBookStatisticViewModel>


  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>;
  get headers(): any[] {
    return [
      {
        text: '',
        align: 'right',
        sortable: false,
        class: 'primary--text dr-table__title '
      },
      {
        text: this.$t(this.lblSetting.dashboardMemberColumnName),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title '
      },
      {
        text: this.$t(this.lblSetting.dashboardMemberColumnTicketOpened),
        align: 'center',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.dashboardMemberColumnTicketTotal),
        align: 'center',
        sortable: false,
        class: 'primary--text dr-table__title'
      }, {
        text: this.$t(this.lblSetting.dashboardMemberColumnResolution),
        align: 'center',
        class: 'primary--text dr-table__title',
        sortable: false
      }

    ]
  }
  get headersViewByContractor(): any[] {
    return [
      {
        text: '',
        align: 'right',
        sortable: false,
        class: 'primary--text dr-table__title '
      },
      {
        text: this.$t(this.lblSetting.dashboardMemberColumnName),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title '
      },
      {
        text: this.$t(this.lblSetting.dashboardMemberColumnTicketOpened),
        align: 'center',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.dashboardMemberTableColumnTicketResolved),
        align: 'center',
        class: 'primary--text dr-table__title',
        sortable: false
      },
      {
        text: this.$t(this.lblSetting.dashboardMemberColumnTicketTotal),
        align: 'center',
        sortable: false,
        class: 'primary--text dr-table__title'
      }

    ]
  }
  get headersViewByBlock(): any[] {
    return [
      {
        text: '',
        align: 'right',
        sortable: false,
        class: 'primary--text dr-table__title '
      },
      {
        text: this.$t(this.lblSetting.dashboardTableColBlockName),
        align: 'left',
        sortable: false,
        class: 'primary--text dr-table__title '
      },
      {
        text: this.$t(this.lblSetting.dashboardMemberColumnTicketOpened),
        align: 'center',
        sortable: false,
        class: 'primary--text dr-table__title'
      },
      {
        text: this.$t(this.lblSetting.dashboardMemberTableColumnTicketResolved),
        align: 'center',
        class: 'primary--text dr-table__title',
        sortable: false
      },
      {
        text: this.$t(this.lblSetting.dashboardMemberColumnTicketTotal),
        align: 'center',
        sortable: false,
        class: 'primary--text dr-table__title'
      }

    ]
  }



  get coLoading(): boolean {
    return this.isLoading
  }
  get coMemberStatisticLoading(): boolean {
    return this.isMemberStatisticLoading
  }
  get coTicketStatisticLoading(): boolean {
    return this.isTicketStatisticLoading
  }
  get start(): string {
    return moment(this.dtSearchParameter.startDate).format('YYYY-MM-DD');
  }
  get end(): string {
    return moment(this.dtSearchParameter.endDate).format('YYYY-MM-DD');
  }
  get coStatisticResolvedData(): any {
    return this.getChartData('amountTicketResolved')
  }
  get coStatisticReportedData(): any {
    return this.getChartData('amountTicketReported')
  }
  get coAverageResolutionTime(): string {
   // console.log(this.averageResolutionTime);

    return this.averageResolutionTime;
  }
  get coMembers(): any {
    return this.membersSource.data;
  }
  get coContractors(): any {
    return this.contractorSource.data;
  }
  get coBlocks(): any {
    return this.blockSource.data;
  }
  get isServiceBookUser():boolean {
    return this.userInfo.template !== UserTemplate.default
  }

  get isServiceBookAgency():boolean {
    return this.userInfo.template === UserTemplate.serviceBookAgency
  }
  get isServiceBookOwner():boolean {
    return this.userInfo.template === UserTemplate.serviceBookOwner
  }

  get coServiceBookSource():any {
console.log('this.serviceBookSource; :>> ', this.serviceBookSource);
    return this.serviceBookSource;
  }
get coServiceBookChartData():any {
  return this.ServiceBookChartData()
}
get coServiceBookLoading(): boolean {
  return this.IsServiceBookSourceLoading
}



  getVisibility(key: "ticket_chart" | "member_tabular") {
    return require("@/assets/json-resources/dashboard-configs.json")[key][this.userInfo.type];
  }
  getStatisticResolvedOptions(key: "blockReportedTicketStatistic" | "blockResolvedTicketStatistic") {
    return {
      ...this.dtChartOptions,
      title: this.$t(this.lblSetting[key], { days: 30 })
    }
  }

  getChartData(key: "amountTicketResolved" | "amountTicketReported") {

    let chartData = JSON.parse(JSON.stringify(this.ticketSource.chartsByDay));

    if (chartData.length === 0) {
      chartData = new Array(30).fill(1).map((x, index) => {
        const date = moment(this.dtSearchParameter.startDate).add(index,'d')
        return {
          date: date.format('YYYY-MM-DD'),
          amountTicketReported: 0,
          amountTicketResolved: 0
        }
      })
    }

    const data = [
      ['Number', '', { role: 'style' }],
      ...chartData.map(x => {
        let label: string = '';
        const dateMoment = moment(x.date);
        if (dateMoment.get('date') % 5 === 0) {
          label = dateMoment.format('DD');
        }
        return [label, x[key], `color: ${key === "amountTicketReported" ? '#f92ac2' : '#00f4d9'};`]
      })
    ]

    return data;
  }
  handleChange(value) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      if (this.$route.meta['stat_view_diagram'])
        this.storeGetTicketStatistic({ start: this.start, end: this.end })
      if (this.$route.meta['stat_view_ticket_by_manager'])
        this.storeGetMemberStatistic({ start: this.start, end: this.end })
      if (this.$route.meta['stat_view_ticket_by_contractor'])
        this.storeGetContractorStatistic({ start: this.start, end: this.end })
      if (this.$route.meta['stat_view_ticket_by_block'])
        this.storeGetBlockStatistic({ start: this.start, end: this.end })
    }, 300);
  }
  getServiceBookChartOptions() {
    return {
      backgroundColor: "transparent",
      fontSize:12,
      fontName:'Raleway',
      tooltip: {
        textStyle:{
          color: "#2E038C",
          fontSize: 12,
          bold: false,
          fontName: "Raleway"
        }
      },
      legend: {
        position: 'bottom',
        alignment: 'center',
        textStyle:{
          color: "#000",
          fontSize: 12,
          bold: false,
          fontName: "Raleway"
        }
      },
      chartArea: { width: '100%' },
      pieHole: 0.45,
      hAxis: {
        minValue: 0,
      },
      height: 300,
      colors: ['#2E038C','#F92AC2', '#00F4D9'],
      pieSliceText: 'value-and-percentage',
    }; 
  }
  ServiceBookChartData(){

    let source = JSON.parse(JSON.stringify(this.coServiceBookSource));
    let serviceBook = source.serviceBook;
    let attachment = source.totalAttachment
    let ticket = source.totalTicket;
     let chartData =  {
      serviceBook : [
        ["Elément", "%"],
        [`Libres (${serviceBook.free})`, serviceBook.free],
        [`Utilisés (${serviceBook.used})`, serviceBook.used],
        [`Expirés(${serviceBook.expired})`,serviceBook.expired]
      ],
      document :  [
        ["Elément", "%"],
        [`Documents (${attachment.document})`, attachment.document],
        [`Images (${attachment.images})`, attachment.images],
        [`Videos (${attachment.videos})`,attachment.videos]
     ],
     ticket :  [
      ["Elément", "%"],
        [`Ouverts (${ticket.open})`, ticket.open],
        [`En cours (${ticket.inProgress})`, ticket.inProgress],
        [`Clôturés(${ticket.close})`,ticket.close]
      ]
     }

    return  chartData
  }
  onChartReady (chart, google) {
    this.chartsLib = google
  }
  getViewHeight() {
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  }

  beforeMount()
  {
    if(localStorage.getItem('token')){
    this.ServiceBookService.getServiceBookProduct().then((response:any[])=>{
      console.log(response)
      this.serviceBookProduct = response
    })
    }
  }

  mounted() {
    if(localStorage.getItem('token')){
        this.storeGetFunctionalities('statistics')
        .then(response => {
          if (this.$route.meta)
            Object.keys(response).forEach(key => this.$route.meta[key] = true)
          if (this.$route.meta['stat_view_diagram'])
            this.storeGetTicketStatistic({ start: this.start, end: this.end })
          if (this.$route.meta['stat_view_ticket_by_manager'])
            this.storeGetMemberStatistic({ start: this.start, end: this.end })
          if (this.$route.meta['stat_view_ticket_by_contractor'])
            this.storeGetContractorStatistic({ start: this.start, end: this.end })
          if (this.$route.meta['stat_view_ticket_by_block'])
            this.storeGetBlockStatistic({ start: this.start, end: this.end })
          if(this.isServiceBookUser) {
            this.storeGetServiceBookStatistic()
          }
        })
      }
    }
  getBadgeCount(value){
    if(value > 100) {
      return '+99'
    } else {
      return value;
    }
  }
  StripeBuyServiceBook(){
    this.buyServiceBookModal = true
  }
  formatDateDownload(date) {
    const parts = date.split("-");
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return date;
  }
  blockRef(ref){
    return ref ? ref.split('-')[1] : '' 
  }
  dateTicket(date){
    return date ? moment(date).format('DD/MM/YYYY') : ''
  }
  generateCSV(data) {
    const headers = [
      'Code',
      this.$t(this.lblSetting.dashboardTableColBlockName),
      this.$t(this.lblSetting.dashboardMemberColumnTicketTotal),
      this.$t(this.lblSetting.dashboardMemberColumnTicketOpened),
      this.$t(this.lblSetting.dashboardMemberTableColumnTicketResolved),
      'Date premier ticket',
      'Date dernier ticket'
    ]
    const separator = ";";
    const csvContent = [headers.join(separator)];
  
    data.forEach(item => {
      const row = [
        this.blockRef(item.blockRef),
        item.name, 
        item.totalTicket,
        item.totalInProgressTicket,
        item.totalResolvedTicket,
        this.dateTicket(item.firstTicketDate),
        this.dateTicket(item.lastTicketDate)
      ];
      csvContent.push(row.join(separator));
    });
  
    return "\ufeff" + csvContent.join("\n"); 
  }
  downloadCSV() {
    const csvContent = this.generateCSV(this.coBlocks);
    const formattedStartDate = this.formatDateDownload(this.start);
    const formattedEndDate = this.formatDateDownload(this.end);
    const filename = `stat-${formattedStartDate}-au-${formattedEndDate}.csv`;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
}

export default HomeContainer;



// WEBPACK FOOTER //
// ./src/containers/home/index.ts